import { ListItemText } from '@mui/material'
import { useDispatch } from 'react-redux'
import { logout } from 'reducers/authReducer'

interface Props {
  styling: any[]
  rtlActive: any
}

export const LogoutListItem: React.FC<Props> = (props) => {
  const { styling, rtlActive } = props
  const dispatch = useDispatch()

  return (
    <ListItemText
      primary={rtlActive ? 'خروج' : 'Log out'}
      disableTypography={true}
      sx={styling}
      onClick={() => dispatch(logout())}
      style={{ cursor: 'pointer' }}
    />
  )
}

export default LogoutListItem
